document.documentElement.classList.add('has-brand-intro-js');

document.addEventListener('DOMContentLoaded', function () {
  const intro = document.querySelector('[data-brand-intro]');
  if (!intro) return;

  document.body.classList.add('has-brand-intro');

  setTimeout(() => {
    intro.classList.add('is-exiting');
    intro.setAttribute('aria-hidden', 'true');

    setTimeout(() => {
      intro.remove();
      document.body.classList.remove('has-brand-intro');
    }, 300);
  }, 600);
});